export default {
    packages_tab_title: 'Paquetes',
    packages_tab_add_packages: 'Agregar Paquete',
    packages_tab_name: 'Nombre',
    packages_tab_project: 'Plataforma',
    packages_tab_dealer: 'Marca',
    packages_tab_created_at: 'Creado en',
    packages_tab_edit: 'Editar',
    packages_tab_account: 'Cuenta',
    packages_tab_assigned: 'Asignado',
    packages_tab_temaple: '* Plantilla',
};